<form [formGroup]="dividendInBox2">
    <div formArrayName="box2Dividend">
        <div *ngFor="let dividend of box2Dividend.controls; let i = index; "
             [formGroupName]="i" class="row">

            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Dividend' : ''"
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="dividendBox2"
                                              id="dividendBox2"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [decimals]="0"
                                              [label]="i === 0 ? 'Dividendbelasting' : ''"
                                              [required]=true
                                              align="right"
                                              class="col-auto custom-input-150"
                                              formControlName="dividendbelastingBox2"
                                              id="dividendbelastingBox2"
                                              prefix="€"

            >
            </snelstart-ui-number-form-control>
            <snelstart-ui-button (click)="verwijderRijDividendBox2(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 iconType="light"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
            <div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="box2Dividend.length === 0">
    <snelstart-ui-button (click)="addRijDividendBox2()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Dividendbelasting box 2 invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box2Dividend.length > 0">
    <snelstart-ui-button (click)="addRijDividendBox2()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Dividendbelasting box 2 toevoegen
    </snelstart-ui-button>
</div>

